import { styled } from '@mui/material/styles';
import { DatagridConfigurableWithStickyActions } from 'shared/react-admin/Datagrids';
import { getColumnStyle } from 'utils';

export const DatagridStyled = styled(DatagridConfigurableWithStickyActions)({
  '& .resize-originId': getColumnStyle(100),
  '& .resize-dateOfOperation': getColumnStyle(120),
  '& .resize-type': getColumnStyle(160),
  '& .resize-direction': getColumnStyle(130),
  '& .resize-amountPenny': {
    ...getColumnStyle(120),
    textAlign: 'right',
  },
  '& .resize-currency': getColumnStyle(90),
  '& .resize-status': getColumnStyle(190),
  '& .resize-referral': getColumnStyle(140),
  '& .resize-merchant': getColumnStyle(160),
  '& .resize-provider': getColumnStyle(140),
  '& .resize-merchantAccount': getColumnStyle(180),
  '& .resize-description': getColumnStyle(220),
  '& .resize-approver': getColumnStyle(160),
  '& .resize-approveAt': getColumnStyle(150),
  '& .resize-canceledAt': getColumnStyle(150),
});
